<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="baseView.mode"
    :hot-key-create-path="'/stock-adjustment/create'"
    :formsConfig="formsConfig"
  >
    <template #headerContent>
      <GcHeaderContentStatic title="Stock Adjustments" />
    </template>
    <div>
      <dx-data-grid
        :ref="gridRefName"
        :data-source="dataSourceConfig"
        :columns="columns"
        @selection-changed="onSelectionChanged($event, rowSelect)"
        @toolbar-preparing="onToolbarPreparing($event)"
        :height="gridHeight"
        @content-ready="addGridNoResults($event)"
        :allow-column-reordering="false"
        :column-chooser="{ enabled: false }"
      >
        <template #status-cell-template="{ data }">
          <gc-status-chip :status="data.data.Status" />
        </template>
        <template #date-in-cell-template="{ data }">
          <gc-friendly-date :date="data.data.DateIn" />
        </template>
      </dx-data-grid>
    </div>
  </gc-main-layout>
</template>

<script>
import BaseViewMixin from "../../v1/_mixins/base.view";
import { StockAdjustmentListService } from "../../_services/api/inventory/stock-adjustment-list.service";

export default {
  props: {},
  mixins: [BaseViewMixin],
  data() {
    return {
      gridRefName: "gridCustomer",
      noDataMessage: {
        addNew: {
          class: "add-new",
          title: "No Adjustments",
          message: "Get Started, Adjust Stock",
        },
      },
      rowSelect: {
        view: this,
        page: "stock-adjustment",
        mode: "review",
        idProperty: "Code",
      },
    };
  },
  components: {},
  created() {},
  computed: {
    dataSourceConfig() {
      return StockAdjustmentListService.dataSourceConfig({
        select: ["Code", "Status", "DateIn"],
        // sort: [{ selector: "Code", desc: true }],
      });
    },
    columns() {
      return this.parseGridColumns("master", [
        {
          gcLabel: "Code",
          dataField: "Code",
          gcType: "String",
          gcSubType: "PrimaryRecord",
          sortOrder: "desc",
        },

        {
          gcLabel: "Date In",
          dataField: "DateIn",
          gcType: "Date",
        },
      ]);
    },
  },
  methods: {
    onToolbarPreparing(e) {
      if (this.formsConfig.createOption) {
        e.toolbarOptions.items.unshift({
          location: "before",
          widget: "dxButton",
          options: {
            icon: "plus",
            text: "Add New",
            onClick: this.onAddClickHandler.bind(this),
          },
        });
      }
    },
    onAddClickHandler() {
      this.$logger.trackEventButtonClickAddNew();
      if (this.formsConfig.editableOption) {
        this.$router.push({
          path: `/stock-adjustment/create`,
        });
      } else {
        this.$router.push({
          name: "unauthorized",
        });
      }
    },
  },
};
</script>

<style lang="scss"></style>
